var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Nombre establecimiento" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { disabled: !_vm.hasPermision("E") },
                        model: {
                          value: _vm.modificationLocal.nombre,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "nombre", $$v)
                          },
                          expression: "modificationLocal.nombre"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Solicitar eliminación" }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "1", sm: "2" } },
                            [
                              _c("switches", {
                                staticStyle: { "margin-top": ".5rem" },
                                attrs: {
                                  disabled: !_vm.hasPermision("E"),
                                  color: "red"
                                },
                                model: {
                                  value: _vm.modificationLocal.eliminado,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.modificationLocal,
                                      "eliminado",
                                      $$v
                                    )
                                  },
                                  expression: "modificationLocal.eliminado"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              !_vm.modification.eliminado
                                ? _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Motivo",
                                      disabled: ""
                                    }
                                  })
                                : _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.modification.eliminado
                                          ? "required"
                                          : "",
                                        expression:
                                          '(modification.eliminado) ? "required": ""'
                                      }
                                    ],
                                    attrs: {
                                      "data-vv-scope": "cambios_identificacion",
                                      placeholder: "Motivo",
                                      disabled: !_vm.hasPermision("E"),
                                      name: "Motivo eliminación"
                                    },
                                    model: {
                                      value:
                                        _vm.modificationLocal.eliminado_motivo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.modificationLocal,
                                          "eliminado_motivo",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "modificationLocal.eliminado_motivo"
                                    }
                                  }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(
                                      "cambios_identificacion.Motivo eliminación"
                                    )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Categoria GN" }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          options: _vm.categoria_gn_comercial_options,
                          "text-field": "categoria_gn_comercial",
                          "value-field": "id",
                          disabled: !_vm.hasPermision("E")
                        },
                        on: { input: _vm.loadTipo },
                        model: {
                          value:
                            _vm.modificationLocal.id_categoria_gn_comercial,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modificationLocal,
                              "id_categoria_gn_comercial",
                              $$v
                            )
                          },
                          expression:
                            "modificationLocal.id_categoria_gn_comercial"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Tipo establecimiento" }
                    },
                    [
                      _c("multiselect", {
                        attrs: {
                          placeholder: "Todas",
                          options:
                            _vm.tipo_establecimiento_gn_comercial_options,
                          label: "tipo",
                          "track-by": "id",
                          disabled:
                            _vm.tipo_establecimiento_gn_comercial_options
                              .length === 0 || !_vm.hasPermision("E")
                        },
                        model: {
                          value:
                            _vm.modificationLocal
                              .id_tipo_establecimiento_comercial,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modificationLocal,
                              "id_tipo_establecimiento_comercial",
                              $$v
                            )
                          },
                          expression:
                            "modificationLocal.id_tipo_establecimiento_comercial"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Código CNAE" }
                    },
                    [
                      _c("multiselect", {
                        attrs: {
                          placeholder: "Seleccionar una opción",
                          selectedLabel: "Seleccionada",
                          "deselect-label": "Click o enter para deseleccionar",
                          "select-label": "Click o enter para seleccionar",
                          "tag-placeholder": "Seleccionar",
                          "custom-label": _vm.customLabelCNAE,
                          options: _vm.cnae_options,
                          label: "descripcion",
                          "track-by": "id",
                          disabled: !_vm.hasPermision("E")
                        },
                        model: {
                          value: _vm.modificationLocal.codigo_cnae,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "codigo_cnae", $$v)
                          },
                          expression: "modificationLocal.codigo_cnae"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Provincia" }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          options: _vm.provincias_options,
                          "text-field": "entity_name",
                          "value-field": "id",
                          disabled: !_vm.hasPermision("E")
                        },
                        on: { input: _vm.loadMunicipio },
                        model: {
                          value: _vm.modificationLocal.provincia,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "provincia", $$v)
                          },
                          expression: "modificationLocal.provincia"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Municipio" }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          "text-field": "entity_name",
                          "value-field": "id",
                          options: _vm.municipio_options,
                          disabled:
                            _vm.municipio_options.length === 0 ||
                            !_vm.hasPermision("E")
                        },
                        on: { input: _vm.loadPoblacion },
                        model: {
                          value: _vm.modificationLocal.municipio,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "municipio", $$v)
                          },
                          expression: "modificationLocal.municipio"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Población" }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          "text-field": "entity_name",
                          "value-field": "id",
                          options: _vm.poblacion_options,
                          disabled:
                            _vm.poblacion_options.length === 0 ||
                            !_vm.hasPermision("E")
                        },
                        model: {
                          value: _vm.modificationLocal.poblacion,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "poblacion", $$v)
                          },
                          expression: "modificationLocal.poblacion"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Tipo vía" }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          options: _vm.tipo_via_options,
                          "text-field": "name_type",
                          "value-field": "name_type",
                          disabled: !_vm.hasPermision("E")
                        },
                        model: {
                          value: _vm.modificationLocal.tipo_via,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "tipo_via", $$v)
                          },
                          expression: "modificationLocal.tipo_via"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "autocomplete",
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Nombre vía" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          autocomplete: "off",
                          name: "Nombre vía",
                          disabled: !_vm.hasPermision("E")
                        },
                        on: { input: _vm.loadNames },
                        model: {
                          value: _vm.modificationLocal.nombre_via,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "nombre_via", $$v)
                          },
                          expression: "modificationLocal.nombre_via"
                        }
                      }),
                      _vm._v(" "),
                      _vm.show_names
                        ? _c(
                            "div",
                            { staticClass: "autocomplete-items" },
                            _vm._l(_vm.names_suggestions, function(
                              element,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  on: {
                                    click: function($event) {
                                      _vm.setElement(element)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(element.street_type.name_type) +
                                      " " +
                                      _vm._s(element.street_name) +
                                      " (" +
                                      _vm._s(element.postal_code_address) +
                                      ")\n                      "
                                  )
                                ]
                              )
                            })
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Número" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { disabled: !_vm.hasPermision("E") },
                        model: {
                          value: _vm.modificationLocal.numero,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "numero", $$v)
                          },
                          expression: "modificationLocal.numero"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Anexo" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { disabled: !_vm.hasPermision("E") },
                        model: {
                          value: _vm.modificationLocal.anexo,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "anexo", $$v)
                          },
                          expression: "modificationLocal.anexo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Dirección no estructurada" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { disabled: !_vm.hasPermision("E") },
                        model: {
                          value:
                            _vm.modificationLocal.direccion_no_estructurada,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modificationLocal,
                              "direccion_no_estructurada",
                              $$v
                            )
                          },
                          expression:
                            "modificationLocal.direccion_no_estructurada"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Código postal" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { disabled: !_vm.hasPermision("E") },
                        model: {
                          value: _vm.modificationLocal.codigo_postal,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modificationLocal,
                              "codigo_postal",
                              $$v
                            )
                          },
                          expression: "modificationLocal.codigo_postal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Latitud" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { disabled: !_vm.hasPermision("E") },
                        model: {
                          value: _vm.modificationLocal.latitud,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "latitud", $$v)
                          },
                          expression: "modificationLocal.latitud"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Longitud" }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { disabled: !_vm.hasPermision("E") },
                        model: {
                          value: _vm.modificationLocal.longitud,
                          callback: function($$v) {
                            _vm.$set(_vm.modificationLocal, "longitud", $$v)
                          },
                          expression: "modificationLocal.longitud"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-form",
                [
                  _c(
                    "b-form-group",
                    {
                      staticStyle: { "font-size": "1rem" },
                      attrs: { label: "Precisión coordenadas" }
                    },
                    [
                      _c("b-form-select", {
                        staticClass: "mb-3",
                        attrs: {
                          options: _vm.coordenadas_options,
                          "text-field": "tipo_precision",
                          "value-field": "id",
                          disabled: !_vm.hasPermision("E")
                        },
                        model: {
                          value: _vm.modificationLocal.id_precision_coordenada,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.modificationLocal,
                              "id_precision_coordenada",
                              $$v
                            )
                          },
                          expression:
                            "modificationLocal.id_precision_coordenada"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-button", { on: { click: _vm.changeLocation } }, [
                _vm._v("Modificar ubicación")
              ]),
              _vm._v(" "),
              _vm.modificationLocal.longitud
                ? _c("b-button", { on: { click: _vm.getLocation } }, [
                    _vm._v("Ver ubicación modificada")
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.hasPermision("B") && _vm.modification.id_comercial
            ? _c(
                "b-col",
                { staticStyle: { "text-align": "left" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: { click: _vm.deleteChanges }
                    },
                    [_vm._v("Eliminar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { disabled: _vm.modificationLocal.new },
                      on: { click: _vm.clearChanges }
                    },
                    [_vm._v("Blanquear")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPermision("E")
            ? _c(
                "b-col",
                { staticStyle: { "text-align": "right" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { disabled: _vm.loading },
                      on: { click: _vm.cancelModification }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          _vm.saveModification($event)
                        }
                      }
                    },
                    [_vm._v("Guardar")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.showAlert
        ? _c(
            "div",
            { staticClass: "div-full" },
            [
              _c(
                "b-alert",
                {
                  staticClass: "alert-class",
                  attrs: { show: "", dismissible: "", variant: "danger" },
                  on: {
                    dismissed: function($event) {
                      _vm.showAlert = false
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.alertText) + "\n      ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details/comercial_cambios_identificacion.vue?vue&type=template&id=3ebc79fc&scoped=true&
// module id = null
// module chunks = 